export const appHead = {"link":[],"meta":[{"charset":"utf-8"},{"key":"viewport","name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"key":"theme-color-light","name":"theme-color","content":"#d9d9d9","media":"(prefers-color-scheme: light)"},{"key":"theme-color-dark","name":"theme-color","content":"#0f172a","media":"(prefers-color-scheme: dark)"},{"property":"og:type","content":"website"}],"style":[],"script":[{"innerHTML":"(function(){try{var r=\"liora-color-mode\",a=localStorage.getItem(r);a&&(a=a.replace(/^['\"]|['\"]$/g,\"\"));var t=window.matchMedia&&window.matchMedia(\"(prefers-color-scheme: dark)\").matches,e=a||\"auto\",c=e===\"dark\"||e!==\"light\"&&t?\"dark\":\"light\";document.documentElement.classList.add(c)}catch{}})();","tagPosition":"head"}],"noscript":[],"htmlAttrs":{}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true

export const clientNodePlaceholder = false